import { getFormSyncErrors } from 'redux-form';

export function syncErrorsSelector(form){
	return (state) => {
		let syncErrors = getFormSyncErrors(form)(state);
		return buildErrorMessages(syncErrors);
	};
}

export function buildErrorMessages(errors = {}){
	let errorEntries = Object.entries(errors);
	let errorMessages = errorEntries.reduce((prev, [name, value]) => {
		if(typeof value === "string") {
			if(value !== null){
				prev.push(value);
			}
		} else if(value !== null && typeof value === "object") {
			prev.push(...buildErrorMessages(value));
		}
		return prev;
	}, []);
	return errorMessages;
}
